import axios from "axios";
import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from "./types";
import { REACT_APP_API_URL } from "../api/global";
import { toast } from "react-toastify";

export const singIn = (token) => {
  return {
    type: LOGIN_SUCCESS,
    token: token,
  };
};

export const logout = () => {
  return {
    type: LOGOUT_SUCCESS,
  };
};

export const getUser = (token, id) => async (dispatch) => {
  dispatch({ type: "FETCH_USER_REQUEST" });
  // if (id == "guest_user") {
  //   dispatch({ type: "SKIP_USER", payload: { is_skip: true } });
  //   return;
  // }

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/getUser/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log(
    //   response.data.data,
    //   "this is data in action user details **********************************888"
    // );
    dispatch({ type: "FETCH_USER_SUCCESS", payload: response.data.data });
    // if (response.data.data?.userVotes == 0) {
    //   toast.info("You have used all free votes.");
    // }
    dispatch({
      type: "SET_VOTE_COUNT",
      payload: response.data.data?.userVotes,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_USER_FAILURE",
      payload: error,
    });
  }
};
